import React, {useState, useRef, useEffect} from "react";

interface ReadMoreProps {
  html: string;
  collapsedHeight?: number;
}

const ReadMore: React.FC<ReadMoreProps> = ({html, collapsedHeight = 180}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState<string>(`${collapsedHeight}px`);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!contentRef.current) return;

    setHeight(
      isOpen ? `${contentRef.current.scrollHeight}px` : `${collapsedHeight}px`,
    );
  }, [isOpen, collapsedHeight]);

  return (
    <div className="relative lg:hidden">
      {/* Content */}
      <div
        ref={contentRef}
        style={{height}}
        className="overflow-hidden transition-all duration-500 ease-in-out pb-8">
        <div
          className="text-valmidnight text-[16px] text-justify"
          dangerouslySetInnerHTML={{__html: html}}
        />
      </div>

      {/* Gradient fade */}
      {/* {!isOpen && (
        <div className="absolute bottom-8 left-0 w-full h-20 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      )} */}

      {/* Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative z-10 underline text-[#2A424B] text-[16px]">
        {isOpen ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

export default ReadMore;
